"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joy_1 = require("@mui/joy");
const react_1 = __importDefault(require("react"));
function widgetButton(props) {
    let border = "1px solid rgb(229, 231, 235)";
    if (props.selected) {
        border = "1px solid rgb(0, 0, 0)";
    }
    return (react_1.default.createElement(joy_1.Box, { width: "100%", height: props.height ? props.height : 50, border: border, onClick: props.onClick, sx: { cursor: 'pointer' } },
        react_1.default.createElement(joy_1.Box, { display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center", width: "100%", height: "100%" }, props.children)));
}
exports.default = widgetButton;
